<div class="tabs dashboard-component-tabs is-boxed is-small is-marginless" >
  <ul>
    <li class="is-active">
      <a><span i18n>Time series</span></a>
    </li>
  </ul>
</div>

@if (plotIds.length === 0) {
  <div class="content-placeholder" i18n>No plot selected.</div>
}
@if (!dataAvailable) {
  <div class="content-placeholder" i18n>No data available.</div>
}

<canvas id="chart" [style.max-height]="'38vh'" [ngClass]="{'invisible': !dataAvailable}" #canvas></canvas>



